import { useState } from 'react'
import PropTypes from 'prop-types'
import { ReleaseRedirect } from 'features/release'
import NavBar from '../components/nav-bar'
import NavBarAccordion from '../components/nav-bar-accordion'
import TopBar from '../components/top-bar'
import { NavigationType } from '../types'
import Box from '@mui/material/Box'

const Frame = ({ children, navigation, accordionNavigation, backgroundImage }) => {

  const [openNavBarMobile, setOpenNavBarMobile] = useState(false)

  const backgroundImageLayoutStyles = {
    minHeight: '100vh',
    position: 'relative',
    '&::before': {
      content: '" "',
      position: 'absolute',
      zIndex: -99,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundImage,
      backgroundSize: '100vw 100vh',
      backgroundPosition: 'left top',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed',
    }
  }

  const sidepanelStyles = {
    borderRight: '1px solid rgba(63,63,68,0.15)',
    boxShadow: 'none',
    zIndex: 3,
    minHeight: 'calc(100vh - 74px)',
  }

  const onNavBarMobileOpen = () =>
    setOpenNavBarMobile(true)

  const onNavBarMobileClose = () =>
    setOpenNavBarMobile(false)

  return (
    <ReleaseRedirect>
      <Box
        sx={{
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          height: '100%',
          width: '100%',
          overflowX: 'hidden', // hide horizontal scrollbar
          ...(backgroundImage && backgroundImageLayoutStyles)
        }}>
        <TopBar onOpenNavBarMobile={onNavBarMobileOpen} />
        {accordionNavigation ? (
          <Box
            sx={{
              display: 'grid',
              gridGap: 0,
              width: '100%',
              minHeight: '100%',
              gridTemplateColumns: '0 minmax(0, 1fr)',
              '@media (min-width: 959px)': {
                gridTemplateColumns: '256px minmax(0, 1fr)'
              },
            }}>
            <NavBarAccordion
              openMostRecentOnLoad
              title="FBT"
              className={sidepanelStyles}
              navigation={accordionNavigation}
              onMobileClose={onNavBarMobileClose}
              openMobile={openNavBarMobile} />
            <Box
              component="main"
              sx={{
                flex: 1,
                width: '100%',
                minWidth: 0,
              }}>
              {children}
            </Box>
          </Box>
        ) : navigation ? (
          <Box
            sx={{
              display: 'grid',
              gridGap: 0,
              width: '100%',
              minHeight: '100%',
              gridTemplateColumns: '80px minmax(0, 1fr)',
              '@media (min-width: 1280px)': { gridTemplateColumns: '256px minmax(0, 1fr)' },
            }}>
            <NavBar
              className={sidepanelStyles}
              navigation={navigation}
              onMobileClose={onNavBarMobileClose}
              openMobile={openNavBarMobile} />
            <Box
              component="main"
              sx={{
                flex: 1,
                width: '100%',
                minWidth: 0,
              }}>
              {children}
            </Box>
          </Box>
        ) : (
          <Box
            component="main"
            sx={{
              flex: 1,
              width: '100%',
              minWidth: 0,
            }}>
            {children}
          </Box>
        )}
        <footer />
      </Box>
    </ReleaseRedirect>
  )
}

Frame.propTypes = {
  backgroundImage: PropTypes.string,
  children: PropTypes.node.isRequired,
  navigation: NavigationType,
}

export default Frame
